
<div class="black-inputs discount-day">

  <el-row>
    <el-row class="dateChooser" :gutter="5">
      <el-input class="discountName" v-model="name" placeholder="Nom de la réduction"></el-input>
      <!-- <el-input  class="discountDesc"  v-model="desc" :autosize="{ minRows: 3}" type="textarea" placeholder="Description de l'évènement"></el-input> -->
    </el-row>
    <el-row class="dateChooser" :gutter="5">
      <el-col :span="24">
        <el-date-picker class="datePicker" ref="picker" v-model="dates" type="daterange" @change="cleanDays()"
          range-separator="au" start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
      </el-col>
    </el-row>
  </el-row>
  <el-row>
    <el-col>
      <el-row v-for="day in labelDays" :key="day" class="day-row">
        <div style="display: flex; align-items: center; width: 100%;">
          <h2>{{ day }}</h2>
          <div style="margin-left: auto; display: flex; align-items: center;">
            <el-switch v-model="switchStates[day]" @change="handleSwitchChange(day)" active-color="#00cec0"
              inactive-color="#e95d5d">
            </el-switch>
          </div>
        </div>
        <el-row v-if="daysData[day] && daysData[day].length > 0" :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="7">
            Heure de début
          </el-col>
          <el-col :span="7">
            Heure de fin
          </el-col>
          <el-col :span="7">
            Taux de réduction (%)
          </el-col>
        </el-row>
        <el-col :span="24" v-for="(range, index) in daysData[day]" :key="index" style="margin-bottom: 10px;">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-time-select v-model="range.hourStart" placeholder="Sélectionner l'heure de début" format="HH:mm"
                :clearable="false"
                :picker-options="getPickerOptions(day, range.hourStart, range.hourEnd, isStart = true, index)"></el-time-select>
            </el-col>
            <el-col :span="7">
              <el-time-select v-model="range.hourEnd" placeholder="Sélectionner l'heure de fin" format="HH:mm"
                :clearable="false"
                :picker-options="getPickerOptions(day, range.hourStart, range.hourEnd, isStart = false, index)"></el-time-select>
            </el-col>
            <el-col :span="7">
              <el-select v-model="range.discount" placeholder="Taux de réduction (%)">
                <el-option v-for="percent in discountOptions" :key="percent" :label="percent + '%'" :value="percent">
                </el-option>
              </el-select>
            </el-col>
            <el-col :offset="1" :span="2">
              <el-button type="danger" icon="el-icon-delete" @click="removeTimeRange(day, index)"></el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24">
          <el-row>
            <el-button v-if="disableAddTimeBtn(day)" class="dark" icon="el-icon-plus" @click="addTimeRange(day)" />
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
  <el-row v-loading="loading">
    <el-col :span="7" :offset="9">
      <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
    </el-col>
    <el-col :span="7" :offset="1">
      <el-button type="primary" @click="validModifications()">Valider</el-button>
    </el-col>
  </el-row>
</div>
